import { Ico } from "../components/icons/icons.jsx";

export const SECTIONS = [
  {
    id: "accounts",
    label: "Accounts",
    icon: Ico.users,
    children: [{ id: "acc-ov", label: "Accounts", icon: Ico.overview }],
  },
  {
    id: "user",
    label: "User",
    icon: Ico.user,
    children: [{ id: "user-ov", label: "User", icon: Ico.user }],
  },
  {
    id: "icp",
    label: "ICP",
    icon: Ico.building,
    children: [{ id: "icp-ov", label: "ICP", icon: Ico.building }],
  },
  {
    id: "devices",
    label: "Devices",
    icon: Ico.device,
    children: [
      { id: "dev-ov", label: "Devices", icon: Ico.device },
      { id: "devtype-ov", label: "Device Types", icon: Ico.model },
    ],
  },
  {
    id: "sim",
    label: "SIM",
    icon: Ico.sim,
    children: [
      { id: "sim-ov", label: "SIM", icon: Ico.sim },
      { id: "simtype-ov", label: "SIM Types", icon: Ico.layers },
    ],
  },
  {
    id: "reports",
    label: "Reports",
    icon: Ico.chartBar,
    children: [{ id: "rpt-bld", label: "Report Builder", icon: Ico.chartBar }],
  },
];
